<template>
    <v-content>
        <v-row class="pb-0 pb-sm-2">
            <v-col class="display-1">
                Список шаблонов
            </v-col>
            <v-col>
                <div class="float-right">
                    <v-btn color="primary" depressed @click="createTemplate()">
                        <v-icon small>mdi-plus</v-icon>
                        Создать
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="4">
                <v-text-field
                    v-model="name"
                    @input="getTemplates"
                    placeholder="Название"
                    outlined
                    hide-details
                    clearable
                    dense
                ></v-text-field>
            </v-col>
            <v-col cols="4">
                <v-select
                    v-model="type.value"
                    @change="getTemplates"
                    :items="types"
                    item-text="name"
                    item-value="value"
                    label="Тип шаблона"
                    outlined
                    hide-details
                    clearable
                    dense
                  />
            </v-col>
        </v-row>
        <b-table
            :data="templates.results"
            :loading="isLoading"
            paginated
            backend-pagination
            :total="templates.total"
            :per-page="perPage.value"
            @page-change="onPageChange"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
            backend-sorting
            :default-sort="[sortField, sortOrder]"
            @sort="onSort"
        >
            <template slot-scope="props">
                <b-table-column field="id" label="ID" centered numeric sortable>
                    {{ props.row.id }}
                </b-table-column>

                <b-table-column field="name" label="Название" centered sortable>
                    {{ props.row.name }}
                </b-table-column>

                <b-table-column field="type" label="Тип" centered>
                    {{ types.find(o => o.value == props.row.type) ? types.find(o => o.value == props.row.type).name : props.row.type }}
                </b-table-column>

                <b-table-column field="created_at" label="Создано" centered sortable>
                    {{ props.row.created_at | isoToDateTime}}
                </b-table-column>

                <b-table-column
                      label="Действия"
                      style="width: 20px;"
                      centered
                  >
                  <b-tooltip
                      label="Изменить">
                      <div
                          @click="updateTemplate(props.row.id)">
                          <b-icon
                              icon="pencil"
                          ></b-icon>
                      </div>
                  </b-tooltip>
                  <b-tooltip
                      label="Удалить">
                      <div
                          @click="deleteTemplate(props.row.id)">
                          <b-icon
                              icon="delete"
                          ></b-icon>
                      </div>
                  </b-tooltip>
                </b-table-column>
            </template>
              <template slot="bottom-left">
                <div class="pagination-controls">
                  <v-select
                    style="width: fit-content; float: left;"
                    v-model="perPage.value"
                    @change="getTemplates"
                    :items="perPageOptions"
                    item-text="name"
                    item-value="value"
                    outlined
                    hide-details
                    dense
                  />
                </div>
            </template>
        </b-table>
    </v-content>
</template>

<script>
import OverlayLoader from "@/app/shared/components/app-loader/Loader";

export default {
    name: 'TemplatesList',
    components: {
        OverlayLoader,
    },
    data() {
        return {
            sortField: "id",
            sortOrder: "desc",
            page: 1,
            name: "",
            perPage: {
                value: 20,
            },
            type: {
                value: null,
            },
            perPageOptions: [
                { name: "10 на странице", value: 10 },
                { name: "20 на странице", value: 20 },
                { name: "50 на странице", value: 50 },
                { name: "100 на странице", value: 100 },
            ],
            types: [
                { name: "Смс", value: 'sms' },
                { name: "Звонок", value: 'call' },
            ],
        }
    },
    created() {
        this.getTemplates();
    },
    computed: {
        templates() {
            return this.$store.getters.TEMPLATES_LIST;
        },
        isLoading() {
            return this.$store.getters.TEMPLATES_LOADING;
        },
    },
    methods: {
        createTemplate() {
          this.$router.push({ path: "/templates/create" });
        },
        updateTemplate(id) {
          this.$router.push({ path: `/templates/update/${id}` });
        },
        getTemplates() {
            const params = {
                sort_by: this.sortField,
                order: this.sortOrder,
                page: this.page,
                perPage: this.perPage.value,
                type: this.type.value,
                name: this.name,
            };
            this.$store.dispatch('GET_TEMPLATES_LIST', params);
        },
        deleteTemplate(templateId) {
            this.$store.dispatch('DELETE_TEMPLATE_NOTIFICATION', templateId)
                .finally(() => {
                    this.$toast.success("Шаблон удален!");
                    this.getTemplates();
                });
        },
        onSort(field, order) {
            this.sortField = field;
            this.sortOrder = order;
            this.getTemplates();
        },
        onPageChange(page) {
            this.page = page;
            this.getTemplates();
        },
    }
}
</script>
